import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import zh from './locales/zh.json'

// Check for global variable injected by server
const serverLocale = (window as any).INITIAL_LOCALE;

const i18n = createI18n({
    legacy: false, // For Vue 3 Composition API
    locale: serverLocale || 'zh',
    fallbackLocale: 'en',
    messages: {
        en,
        zh
    }
})

export default i18n
